import { render } from "./RequestMail.vue?vue&type=template&id=88b1f5ae&scoped=true"
import script from "./RequestMail.vue?vue&type=script&lang=js"
export * from "./RequestMail.vue?vue&type=script&lang=js"

import "./RequestMail.vue?vue&type=style&index=0&id=88b1f5ae&scoped=true&lang=css"

import exportComponent from "/home/mugonat-caaz-omnibox/htdocs/caaz-omnibox.mugonat.com/releases/21/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b1f5ae"]])

export default __exports__